/**
 * @desc resetPassword
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.UserPasswordRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/usr/resetPassword`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
